export default class FotobookPhotoSelector {
  constructor() {
    console.log('FotobookPhotoSelector: Constructor called');
    this.selectedFiles = [];
    this.maxFiles = window.FOTOBOOK_CONFIG?.totalSheets || 20; // totalSheets = páginas
    console.log(`FotobookPhotoSelector: Max files (pages) set to ${this.maxFiles}`);
    this.init();
  }

  init() {
    this.initializeFileInput();
    this.updateFileCounter();
  }

  initializeFileInput() {
    const fileInput = document.querySelector('.input-files');
    if (!fileInput) return;

    // Guardar referencia para poder resetear el valor tras procesar
    this.fileInput = fileInput;

    // Configurar el input de archivos
    fileInput.addEventListener('change', (e) => {
      this.handleFileSelection(e.target.files);
    });

    // Configurar el atributo accept
    fileInput.setAttribute('accept', 'image/*');
    fileInput.setAttribute('multiple', 'true');
  }

  handleFileSelection(files) {
    const validFiles = Array.from(files).filter(file => {
      return file.type.startsWith('image/');
    });

    // Calcular espacio disponible
    const remainingSlots = this.maxFiles - this.selectedFiles.length;
    if (remainingSlots <= 0) {
      this.showAlert(`Ya alcanzaste el máximo de ${this.maxFiles} fotos`);
      // Limpiar el input para permitir reintentos
      if (this.fileInput) this.fileInput.value = '';
      return;
    }

    // Tomar solo los que caben
    const filesToAdd = validFiles.slice(0, remainingSlots);
    if (validFiles.length > remainingSlots) {
      this.showAlert(`Solo se agregaron ${remainingSlots} foto(s). Límite: ${this.maxFiles}`);
    }

    // Agregar archivos válidos dentro del límite
    filesToAdd.forEach(file => {
      this.selectedFiles.push(file);
    });

    this.updateFileCounter();
    this.updateFileList();
    this.checkPrintButton();

    // Limpiar el input para permitir volver a seleccionar (incluido repetir archivos)
    if (this.fileInput) this.fileInput.value = '';
  }

  updateFileCounter() {
    const counter = document.querySelector('#photos-selected-counter');
    if (counter) {
      counter.textContent = `${this.selectedFiles.length}`; // / ${this.maxFiles}`;
    }
  }

  updateFileList() {
    const fileList = document.querySelector('#selected-files-list');
    if (!fileList) return;

    fileList.innerHTML = '';
    // Asegurar layout de grilla de 3 columnas para miniaturas
    fileList.classList.add('grid', 'grid-cols-3', 'gap-2');

    this.selectedFiles.forEach((file, index) => {
      const fileItem = document.createElement('div');
      fileItem.className = 'relative overflow-hidden rounded bg-gray-100';

      fileItem.innerHTML = `
        <img src="${URL.createObjectURL(file)}" alt="Preview" class="cursor-grab w-full block object-cover" style="aspect-ratio: 1 / 1;" draggable="true" data-file-index="${index}" />
        <button type="button" class="absolute top-1 right-1 text-white bg-red-500/80 hover:bg-red-600 rounded-full w-7 h-7 flex items-center justify-center" onclick="fotobookPhotoSelector.removeFile(${index})" aria-label="Eliminar">
          <i class="fas fa-times"></i>
        </button>
      `;

      // Agregar manejador de dragstart al img
      const imgEl = fileItem.querySelector('img');
      if (imgEl) {
        imgEl.addEventListener('dragstart', (ev) => {
          try {
            ev.dataTransfer.setData('text/fotobook-file-index', String(index));
            ev.dataTransfer.effectAllowed = 'copy';
          } catch (_) {}
        });
      }

      fileList.appendChild(fileItem);
    });
  }

  removeFile(index) {
    this.selectedFiles.splice(index, 1);
    this.updateFileCounter();
    this.updateFileList();
    this.checkPrintButton();
  }

  checkPrintButton() {
    const printButton = document.querySelector('#send-to-print-btn');
    if (!printButton) {
      console.log('FotobookPhotoSelector: Print button not found');
      return;
    }

    console.log(`FotobookPhotoSelector: Checking print button. Files: ${this.selectedFiles.length}/${this.maxFiles}`);

    if (this.selectedFiles.length === this.maxFiles) {
      printButton.classList.remove('disabled');
      printButton.disabled = false;
      console.log('FotobookPhotoSelector: Print button enabled');
    } else {
      printButton.classList.add('disabled');
      printButton.disabled = true;
      console.log('FotobookPhotoSelector: Print button disabled');
    }
  }

  showAlert(message) {
    // Crear un alert temporal
    const alert = document.createElement('div');
    alert.className = 'fixed top-4 right-4 bg-red-500 text-white px-4 py-2 rounded shadow-lg z-50';
    alert.textContent = message;
    
    document.body.appendChild(alert);
    
    setTimeout(() => {
      alert.remove();
    }, 3000);
  }

  getSelectedFiles() {
    return this.selectedFiles;
  }

  clearFiles() {
    this.selectedFiles = [];
    this.updateFileCounter();
    this.updateFileList();
    this.checkPrintButton();
  }
} 